/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';

import { take, tap, switchMap, map, delay, filter } from 'rxjs/operators';

import { AppState } from '../app-state.service';
import { Observable, of } from 'rxjs';

import { PROJECT_ACCESS_ON_LOAD } from '@touchplan/strings';

/**
 * A onActivate route guard that checks if you have access to a project. Lets you continue if you do, and redirects you
 * to the projects page if you do not.
 */
@Injectable()
export class ProjectAccessGuard {
	constructor(private router: Router, private appState: AppState) {}

	public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
		const projectId = route.paramMap.get('projectId');

		return this.appState.user.pipe(
			filter((user) => !!user),
			map((user) => {
				if (!user.indices) {
					return false;
				}
				return user.indices.has(projectId);
			}),
			//convert access check into a successful load, or a redirect with a warning and delay
			switchMap((hasAccess) => {
				if (hasAccess) {
					return of(hasAccess);
				} else {
					this.logError();
					return of(false).pipe(
						delay(2000),
						tap((f) => this.redirectToProjects())
					);
				}
			}),
			take(1)
		);
	}
	public redirectToProjects() {
		this.router.navigate(['/projects']);
	}

	private logError() {
		Logging.warning(PROJECT_ACCESS_ON_LOAD);
	}
}
